import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { DEAL_HISTORY_INFO } from '../../constants/DealHistoryConstants';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const DealHistoryTooltip = ({
  children,
  property,
  changeDirection,
  changeAmount
}) => {
  if (!children) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  //this is our usage in the old table
  if (!property || !changeDirection || !changeAmount) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealTable.propertyChange.tooltipNew"
      }),
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: DEAL_HISTORY_INFO[property][changeDirection].tooltipText || '',
      options: {
        propertyChange: I18n.formatPercentage(Math.abs(changeAmount))
      }
    }),
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })
  });
};